import { Paper, Typography } from '@mui/material';
import React from 'react';

const ConfirmSwapModalErrorMsg = ({ message }: { message: string }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        borderRadius: '12px',
        padding: '8px 14px',
        backgroundColor: 'widget.bg-alert-error',
      }}>
      <Typography
        variant="rsm14"
        sx={{
          color: 'widget.text-primary',
          lineHeight: '16px',
        }}>
        {message}
      </Typography>
    </Paper>
  );
};

export default ConfirmSwapModalErrorMsg;
